/* global window */

import Vue from 'vue';
import _ from 'lodash';
import { mapState } from 'vuex';
import $ from 'jquery';

// Components
import QdYoutubeVideo from '../../youtube-video/youtube-video.js';
import QdContent from '../../content/content.js';
import Userbar from '../../userbar/userbar'

// Mixins
import { RestComponent } from '../../../mixins/rest-component';
import { ReplyForm } from '../../../mixins/reply-form';

// Template and media files
import template from '../shared-template/page-listing.vhtml';
import logo from '../../../../_img/logo-esbjerghavn.svg';

export const PagePublicListing = Vue.component('page-public-listing', {
	components: {
		QdYoutubeVideo,
		QdContent,
		logo,
		Userbar
	},
	mixins: [
		RestComponent,
		ReplyForm
	],
	template: template,
	props: {
	},
	data() {
		return {
			userCreate: false,
			hideMoreThan300: false,
			hideMoreThan500: false,
		}
	},
	computed: {
		...mapState({
			videoIsShown: state => state.youtubeVideo.isShown,
			showLogo: state => state.content.showLogo,
			showIndexLocation: state => state.content.showIndexLocation,
			fixedWidgetIsFixed: state => state.fixedWidget.isFixed,
			isNavigating: state => state.pages.isNavigating,
		}),
		showeula: function () {
			return false;
		},
		reduce: function () {
			return label => label.value
		}
	},
	watch: {
		content() {
			this.$store.commit('sidebar/updateData', {
				name: 'parent',
				value: this.content.parent,
			});
			this.$store.commit('pagination/updateData', {
				name: 'currentPage',
				value: this.content.name,
			});
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		toogleScrollElements() {
			window.pageYOffset > 300 ? this.hideMoreThan300 = true : this.hideMoreThan300 = false;
			window.pageYOffset > 500 ? this.hideMoreThan500 = true : this.hideMoreThan500 = false;
			if (!this.isNavigating) {
				if (this.$el.clientWidth > 754) {
					if (window.pageYOffset + window.innerHeight > this.$el.clientHeight - 301) {
						if (this.fixedWidgetIsFixed) {
							this.$store.commit('fixedWidget/updateData', {
								name: 'isFixed',
								value: false,
							});
						}
					} else {
						if (!this.fixedWidgetIsFixed) {
							this.$store.commit('fixedWidget/updateData', {
								name: 'isFixed',
								value: true,
							});
						}
					}
				} else {
					if (window.pageYOffset + window.innerHeight > this.$el.clientHeight - 565) {
						if (this.fixedWidgetIsFixed) {
							this.$store.commit('fixedWidget/updateData', {
								name: 'isFixed',
								value: false,
							});
						}
					} else {
						if (!this.fixedWidgetIsFixed) {
							this.$store.commit('fixedWidget/updateData', {
								name: 'isFixed',
								value: true,
							});
						}
					}
				}
			}
		}
	},
	created() {
		this.$store.dispatch('dictionary/resetTerms');
		this.$store.commit('fixedWidget/updateData', {
			name: 'isFixed',
			value: true,
		});
		setTimeout(() => {
			this.$store.commit('pagination/updateData', {
				name: 'outOfViewPos',
				value: '',
			});
		}, 500);
		this.$nextTick(function () {
			this.$options.throttleFunction = _.throttle(this.toogleScrollElements, 25);
			window.addEventListener('scroll', this.$options.throttleFunction);
		});
	},
	mounted() {
		setTimeout(() => {
			$('html').removeClass('no-scroll');
			this.$store.dispatch('youtubeVideo/show');
			this.$store.dispatch('content/show');
		}, 1000)
	},
	beforeDestroy() {
		this.$store.commit('fixedWidget/updateData', {
			name: 'isFixed',
			value: true,
		});
		this.$store.dispatch('youtubeVideo/hide');
		this.$store.dispatch('content/hide');
		window.removeEventListener('scroll', this.$options.throttleFunction);
	}
});



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-public-listing/page-public-listing.js